// extracted by mini-css-extract-plugin
export var closeButton = "_p4-2";
export var closeButtonIcon = "_p4-3";
export var lightboxContent = "_p4-1";
export var lightboxOverlay = "_p4-0";